import React from "react";
import { MessageCircle } from "lucide-react";

const ContactSection = () => {
  const openTelegram = (handle) => {
    const message = "Hi! I'm interested in your Telegram setup services for my crypto project. Can you provide more information?";
    window.open(`https://t.me/${handle}?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <section id="contact" className="py-14 px-4 min-h-screen flex flex-col justify-center">
      <div className="max-w-4xl mx-auto w-full">
        <div className="text-center mb-10">
          <h2 className="display-large mb-4">Get Started Today</h2>
          <p className="body-large">
            Ready to build a professional Telegram presence for your crypto project? Contact us now!
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Contact Tiago */}
          <div 
            className="p-8 border border-gray-800 rounded-lg dark-hover dark-transition"
            style={{ background: 'rgba(18, 18, 18, 0.8)', borderColor: 'var(--border-subtle)' }}
          >
            <div className="text-center">
              <MessageCircle size={40} className="mx-auto mb-4" color="var(--brand-primary)" />
              <h4 className="heading-3 mb-3">Contact Tiago on Telegram</h4>
              <p className="body-small text-gray-400 mb-6">
                Message Tiago directly on Telegram for immediate assistance
              </p>
              <button 
                onClick={() => openTelegram('tiago_m7')}
                className="btn-secondary dark-button-animate w-full"
                style={{ minHeight: '48px', padding: '10px 18px' }}
              >
                <MessageCircle size={20} />
                @tiago_m7
              </button>
            </div>
          </div>

          {/* Contact XCHNG */}
          <div 
            className="p-8 border border-gray-800 rounded-lg dark-hover dark-transition"
            style={{ background: 'rgba(18, 18, 18, 0.8)', borderColor: 'var(--border-subtle)' }}
          >
            <div className="text-center">
              <MessageCircle size={40} className="mx-auto mb-4" color="var(--brand-primary)" />
              <h4 className="heading-3 mb-3">Contact XCHNG on Telegram</h4>
              <p className="body-small text-gray-400 mb-6">
                Message XCHNG directly on Telegram for immediate assistance
              </p>
              <button 
                onClick={() => openTelegram('xXCHNGx')}
                className="btn-secondary dark-button-animate w-full"
                style={{ minHeight: '48px', padding: '10px 18px' }}
              >
                <MessageCircle size={20} />
                @xXCHNGx
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
